<template>
  <div>
    <section class="top">
      <div class="header">
        <div class="header-svg clouds"></div>
        <div class="container">
          <div class="columns">
            <div class="column is-6">
              <h1 class="title is-1 has-text-left mb-6" ref="logo">Woordjes leren</h1>
              <p class="subtitle is-5" ref="logotext">Ikleeralles.nl is hét overhoorprogramma om online woordjes te leren. Bij ons kun je in weinig tijd je woordenlijst invullen en zoveel mogelijk leren!</p>
              <div class="buttons">
                <b-button tag="router-link" to="/aanmelden" type="is-primary" size="is-medium" icon-right="arrow-right">Aan de slag</b-button>
              </div>
            </div>
            <div class="column is-5 is-offset-1" style="position: relative;">
              <video class="video header-image" onloadeddata="this.play();" playsinline loop muted>
                <source src="@/assets/videos/overhoren.mp4" />
              </video>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body mt-5">
        <div class="container">
          <div class="columns">
            <div class="column is-half">
              <img alt="overhoormethodes" class="pr-5" src="@/assets/screenshots/overhoormethodes.png" />
            </div>
            <div class="column is-half">
              <div class="lead">
                <h1 class="title">
                  De nieuwste opties.
                  <span class="anotherhand">Om nog beter te leren</span>
                </h1>
                <p class="is-size-4">
                  Wij bieden veel verschillende overhooropties aan en we hebben recent een nieuwe optie ontwikkeld: <strong>Willekeurig</strong> <br /><br />
                  Met deze overhooroptie krijg je willekeurge vragen: <i>meerkeuze</i>, <i>gedachten</i> of <i>typen</i>. Daarnaast komen ook voorbeeldzinnen naar voren waar je het ontbrekende woord moet invullen.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero is-white">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-half">
              <div class="lead">
                <h1 class="title">
                  Voorbeeldzinnen.
                  <span class="anotherhand">Welk woord ontbreekt?</span>
                </h1>
                <p class="is-size-4">
                  Op Ikleeralles.nl kun je goed woordjes leren door jezelf te overhoren. Je kunt hier gebruik maken van de instellingen die je gewend bent. Typ je graag het antwoord in, of overhoor je jezelf liever in gedachten? Het kan allebei, met nog veel meer geavanceerde overhoorinstellingen.
                  <br /><br />
                  Zonder je ouders kun je nu dus nog beter online leren en jezelf voorbereiden op je aankomende toets of overhoring.
                </p>
              </div>
            </div>
            <div class="column is-half">
              <img alt="woordjes overhoren" class="pl-5" ref="image1" src="@/assets/screenshots/voorbeeldzin.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <div class="columns">
            <div class="column is-half has-text-right">
              <img alt="overhoorresultaten" class="pr-5" ref="image1" width="70%" src="@/assets/undraw/result.svg" />
            </div>
            <div class="column is-half">
              <div class="lead">
                <h1 class="title">
                  Het beste resultaat.
                  <span class="anotherhand">In de minste tijd</span>
                </h1>
                <p class="is-size-4">
                  Op Ikleeralles.nl kun je goed woordjes leren door jezelf te overhoren. Je kunt hier gebruik maken van de instellingen die je gewend bent. Typ je graag het antwoord in, of overhoor je jezelf liever in gedachten? Het kan allebei, met nog veel meer geavanceerde overhoorinstellingen.
                  <br /><br />
                  Zonder je ouders kun je nu dus nog beter online leren en jezelf voorbereiden op je aankomende toets of overhoring.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero">
      <div class="hero-body">
        <div class="container has-text-centered">
          <h3 class="title is-2 anotherhand">Klaar om aan de slag te gaan?</h3>
          <b-button tag="router-link" to="/aanmelden" size="is-large" type="is-success">Registreren</b-button>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {}
</script>
<style lang="scss" scoped>
@use "~@/assets/style/landing.scss";

.video {
  -webkit-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}
</style>
